var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "installment-bank-calc"
  }, [_c('Form', {
    attrs: {
      "type": "vertical"
    }
  }, [_c('div', {
    staticClass: "installment-bank-calc__form"
  }, [_c('div', {
    staticClass: "installment-bank-calc__fields"
  }, [_c('FormElement', {
    staticClass: "mb-18",
    attrs: {
      "title": "Стоимость товара",
      "hint-min-height": "0"
    }
  }, [_c('RangeInput', {
    attrs: {
      "value": _vm.installmentSettings.price,
      "min": _vm.data.price.min || 3000,
      "max": _vm.data.price.max,
      "postfix": "₽",
      "type": "touch"
    },
    on: {
      "change": function ($event) {
        return _vm.debounceChange('price', $event);
      }
    }
  })], 1), _vm._v(" "), _c('FormElement', {
    staticClass: "mb-18",
    attrs: {
      "title": "Первоначальный взнос",
      "helper": "Не ниже 30% от стоимости товара"
    }
  }, [_c('RangeInput', {
    attrs: {
      "value": _vm.installmentSettings.first_fee_in_rouble,
      "min": _vm.firstFeeRange.min,
      "max": _vm.firstFeeRange.max,
      "postfix": "₽",
      "type": "touch"
    },
    on: {
      "change": function ($event) {
        return _vm.debounceChange('first_fee_in_rouble', $event);
      }
    }
  })], 1), _vm._v(" "), _c('FormElement', {
    staticClass: "mb-18",
    attrs: {
      "title": "Срок договора"
    }
  }, [_c('RangeInput', {
    attrs: {
      "value": _vm.installmentSettings.period,
      "min": _vm.data.period.min,
      "max": _vm.data.period.max,
      "postfix": "мес",
      "type": "touch"
    },
    on: {
      "change": function ($event) {
        return _vm.debounceChange('period', $event);
      }
    }
  })], 1)], 1), _vm._v(" "), _vm.error ? _c('StatusBlock', {
    attrs: {
      "size": "m",
      "type": "error",
      "description": _vm.error.description
    }
  }) : _vm.loading ? _c('StatusBlock', {
    attrs: {
      "size": "m",
      "type": "loading",
      "padding": "27px 20px"
    }
  }) : _c('PriceSummary', {
    staticClass: "installment-bank-calc__summary",
    attrs: {
      "title": "Ежемесячный платеж",
      "loading": _vm.loading,
      "total": _vm.totalText,
      "list": _vm.summaryList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "installment-bank-calc__bottom"
  }, [_c('div', {
    staticClass: "installment-bank-calc__share",
    on: {
      "click": function ($event) {
        return _vm.emit('share');
      }
    }
  }, [_vm._v("\n      Поделиться\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "installment-bank-calc__qr installment-bank-calc__qr_desktop",
    on: {
      "click": function ($event) {
        return _vm.emit('qr-code');
      }
    }
  }, [_vm._v("\n      Отсканировать Qr-code\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "installment-bank-calc__qr installment-bank-calc__qr_mobile",
    on: {
      "click": function ($event) {
        return _vm.emit('qr-code');
      }
    }
  }, [_vm._v("\n      Отсканировать\n    ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }